var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1To1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "hidden",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6 7c-.5.4-1.1.7-1.9.9v2c.5-.1 1.1-.3 1.4-.5.3-.2.7-.4 1.1-.7v5.7h2.4V5.6H5.7c-.3.6-.6 1-1.1 1.4zM15 5.6c-.3.6-.6 1-1.1 1.4-.5.4-1.1.7-1.9.9v2c.5-.1 1.1-.3 1.4-.5.3-.2.7-.4 1.1-.7v5.7h2.4V5.6H15zM11.1 8.4a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zM11.1 11.8a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1To1);
export default __webpack_public_path__ + "static/media/1-to-1.4fd5b5cf.svg";
export { ForwardRef as ReactComponent };